<template>
  <div>
    <form-viewer
      :dataShape="dataShape"
      :selectedObject="object"
      :collectionDBname="collectionDBname"
    ></form-viewer>
  </div>
</template>
<script>
import FormViewer from "../components/UI/Form/FormViewer"

export default {
  data() {
    return {}
  },

  mounted() {
    /* this.$nextTick(function() {
      this.isLoading = false
    }) */
  },
  methods: {},
  updated: function() {
    this.$nextTick(function() {
      // Code that will run only after the
      // entire view has been re-rendered
    })
  },
  components: {
    FormViewer,
  },
  props: ["collectionDBname"],
  watch: {
    collectionDBname() {
      console.log("Watch", this.collectionDBname)
    },
  },
  computed: {
    //...mapGetters([this.collectionDBname]),
    extraInfo() {
      return this.$store.getters[`${this.collectionDBname}_extraInfo`]
    },
    object() {
      return this.$store.getters[this.collectionDBname]
    },
    dataShape() {
      return this.$store.getters[`${this.collectionDBname}_dataShape`]
    },
  },
}
</script>
